var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBookingTypeContractIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 77.871,
    height: 77.879,
    viewBox: "0 0 77.871 77.879",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Path_41038",
    x: 0,
    y: 0,
    width: 77.871,
    height: 30.196,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_41039",
    x: 0,
    y: 12.203,
    width: 77.871,
    height: 65.676,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffcd56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff983c"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9115",
    "data-name": "Group 9115",
    transform: "translate(-34.065 -407.056)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 34.06, 407.06)",
    filter: "url(#Path_41038)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_41038-2",
    "data-name": "Path 41038",
    d: "M52.725,0h-51A1.731,1.731,0,0,0,0,1.725V10.47A1.731,1.731,0,0,0,1.725,12.2h56.42a1.731,1.731,0,0,0,1.726-1.726V1.725A1.731,1.731,0,0,0,58.145,0Z",
    transform: "translate(9 6)",
    fill: "#E75A7C"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    "data-name": "Group"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 34.06, 407.06)",
    filter: "url(#Path_41039)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_41039-2",
    "data-name": "Path 41039",
    d: "M10.595,0H1.725A1.731,1.731,0,0,0,0,1.726V45.95a1.731,1.731,0,0,0,1.725,1.726h56.42a1.731,1.731,0,0,0,1.726-1.726V1.725A1.731,1.731,0,0,0,58.145,0H10.595Z",
    transform: "translate(9 18.2)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_18977",
    "data-name": "Rectangle 18977",
    d: "M0,0H9.99V9.988H0Z",
    transform: "translate(48.306 431.017)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_18978",
    "data-name": "Rectangle 18978",
    d: "M0,0H9.989V9.988H0Z",
    transform: "translate(61.215 431.017)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_18979",
    "data-name": "Rectangle 18979",
    d: "M0,0H9.989V9.988H0Z",
    transform: "translate(74.123 431.017)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_18980",
    "data-name": "Rectangle 18980",
    d: "M0,0H9.99V9.989H0Z",
    transform: "translate(48.306 443.966)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_18981",
    "data-name": "Rectangle 18981",
    d: "M0,0H9.989V9.989H0Z",
    transform: "translate(61.215 443.966)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_18982",
    "data-name": "Rectangle 18982",
    d: "M0,0H9.989V9.989H0Z",
    transform: "translate(74.123 443.966)",
    fill: "#E75A7C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_18983",
    "data-name": "Rectangle 18983",
    d: "M0,0H9.989V9.988H0Z",
    transform: "translate(87.388 431.017)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_18984",
    "data-name": "Rectangle 18984",
    d: "M0,0H9.989V9.989H0Z",
    transform: "translate(87.388 443.966)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_18985",
    "data-name": "Rectangle 18985",
    d: "M0,0H9.989V9.988H0Z",
    transform: "translate(48.465 456.895)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_18986",
    "data-name": "Rectangle 18986",
    d: "M0,0H9.989V9.988H0Z",
    transform: "translate(61.374 456.895)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_18987",
    "data-name": "Rectangle 18987",
    d: "M0,0H9.989V9.988H0Z",
    transform: "translate(74.282 456.895)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_18988",
    "data-name": "Rectangle 18988",
    d: "M0,0H9.989V9.988H0Z",
    transform: "translate(87.547 456.895)",
    fill: "url(#linear-gradient)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookingTypeContractIcon);
export default __webpack_public_path__ + "static/media/booking-type-contract-icon.87fd2380ff796e384c3ee0d2317c5b7d.svg";
export { ForwardRef as ReactComponent };